export default {
    login: 'Login',
    logout: 'Logout',
    signIn: 'Anmelden',
    stayLoggedIn: 'Angemeldet bleiben',
    forgotPassword: 'Passwort vergessen?',
    registerHere: 'Hier registrieren',
    noAccountQuestion: 'Noch kein Account?',
    pleaseWait: 'Bitte warten',
    register: 'Registrieren',
    registerText: 'Noch keinen Account?',
    registerCallToAction: 'Jetzt registrieren',

    impersonationAborted: 'Die Support Sitzung musste abgebrochen werden.',
    impersonationError: 'Bei der Support Sitzung ist ein Fehler aufgetreten.',
    sessionTimeout: 'Deine Sitzung ist abgelaufen.',
    pleaseLoginAgain: 'Bitte melde dich erneut an.',

    email: 'E-Mail',
    password: 'Passwort',
    repeatPassword: 'Passwort wiederholen',
    savePassword: 'Passwort speichern',
    pleaseEnterNewPassword: 'Bitte gib ein neues Passwort ein.',
    firstname: 'Vorname',
    lastname: 'Nachname',
    organisation: 'Organisation',
    organisationHelpText: 'Um sich registrieren zu können, musst du den Authentifizierungscode deiner Organisation erhalten haben und hier eingeben.',

    loginError: 'Fehler beim Anmelden',
    loginSportUsers: 'Sport-Nutzer können sich nur über die Sport-Schnittstelle anmelden',
    tooManyLoginAttempts: 'Zu viele Anmeldeversuche. Bitte warte eine Minute und versuche es dann erneut.',

    emailVerified: 'E-Mailadresse wurde erfolgreich bestätigt.',
    emailVerificationFailed: 'Die E-Mailadresse konnte nicht bestätigt werden. Grund: {reason}',
    emailVerificationFailedReasons: {
        forbidden: 'Du bist nicht dazu berechtigt, diese E-Mailadresse zu bestätigen.',
        notAuthenticated: 'Du musst mit dem Nutzerkonto angemeldet sein, für das du die E-Mailadresse bestätigen möchtest.',
        invalidSignature: 'Der Link ist ungültig oder abgelaufen. Bitte fordere einen neuen Bestätigungslink an.',
    },

    back: 'Zurück',
    forgotPasswordText:
        'Bitte gebe deine E-Mail-Adresse ein. Wir senden dir dann einen Link zum Zurücksetzen deine Passworts zu.',
    forgotPasswordSuccess: 'Es wurde eine E-Mail zum Zurücksetzen des Passworts an deine E-Mail Adresse gesendet.',
    resetPassword: 'Passwort zurücksetzen',
    resetPasswordSuccessTitle: 'Dein Passwort wurde erfolgreich geändert',
    resetPasswordSuccessText: 'Du kannst dich jetzt mit dem neuen Passwort anmelden.',
    socialRedirecting: 'Du wirst weitergeleitet...',
    socialError: 'Bei der Anmeldung ist ein Fehler aufgetreten.',
    orContinueWith: 'oder weiter mit'
}
